import Bundle from "@framework/Bundle";

export const routes = require.context(
	"./",
	true,
	/.*\/@module($|\/routes\.(js))/
);

/* webpack-strip-block:removed */
/* REMOVE-FOR-SERVER-START */
/* REMOVE-FOR-CLIENT-SSR-START */
export const controllers = [{value: () => import(/* webpackPreload: true */ "./@module/controller.js"), path: "./@module/controller.js"}, {value: () => import(/* webpackPreload: true */ "./Estimates/@module/controller.js"), path: "./Estimates/@module/controller.js"}, {value: () => import(/* webpackPreload: true */ "./Invoices/@module/controller.js"), path: "./Invoices/@module/controller.js"}, {value: () => import(/* webpackPreload: true */ "./InvoicesNew/@module/controller.js"), path: "./InvoicesNew/@module/controller.js"}, {value: () => import(/* webpackPreload: true */ "./MembershipsList/@module/controller.js"), path: "./MembershipsList/@module/controller.js"}, {value: () => import(/* webpackPreload: true */ "./Transactions/@module/controller.js"), path: "./Transactions/@module/controller.js"}];
export const models = [];
/* REMOVE-FOR-CLIENT-SSR-END */
export const libs = [];
export const styles = [{value: () => import(/* webpackPreload: true */ "./@styles/Invoices.styles.js"), path: "./@styles/Invoices.styles.js"}, {value: () => import(/* webpackPreload: true */ "./@styles/Sales.styles.js"), path: "./@styles/Sales.styles.js"}, {value: () => import(/* webpackPreload: true */ "./@styles/Transactions.styles.js"), path: "./@styles/Transactions.styles.js"}];
export const constants = [];
export const loadable = require.context("./", true, /\.(loadable)\.(js)$/);
export const stores = [];
export const extensions = [];
export const background = require.context("./", true, /\.(background)\.(js)$/);
/* webpack-strip-block:removed */
/* webpack-strip-block:removed */
/* REMOVE-FOR-SERVER-END */
